var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container bairun-bianlidian-spugroup" },
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: {
                inline: true,
                model: _vm.searchInfo,
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "分组名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.spuGroupName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "spuGroupName", $$v)
                      },
                      expression: "searchInfo.spuGroupName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品spu" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.spuNo,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "spuNo", $$v)
                      },
                      expression: "searchInfo.spuNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "是否热销" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择"
                      },
                      model: {
                        value: _vm.searchInfo.isHot,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "isHot", $$v)
                        },
                        expression: "searchInfo.isHot"
                      }
                    },
                    [
                      _c(
                        "el-option",
                        { key: 1, attrs: { label: "是", value: 1 } },
                        [_vm._v("是")]
                      ),
                      _c(
                        "el-option",
                        { key: 2, attrs: { label: "否", value: 2 } },
                        [_vm._v("否")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择"
                      },
                      model: {
                        value: _vm.searchInfo.spuGroupStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "spuGroupStatus", $$v)
                        },
                        expression: "searchInfo.spuGroupStatus"
                      }
                    },
                    [
                      _c(
                        "el-option",
                        { key: 1, attrs: { label: "启用", value: 1 } },
                        [_vm._v("启用")]
                      ),
                      _c(
                        "el-option",
                        { key: 2, attrs: { label: "禁用", value: 2 } },
                        [_vm._v("禁用")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onAdd } },
                    [_vm._v("新增")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "tooltip-effect": "dark",
            "row-key": "spuGroupNo",
            "expand-row-keys": _vm.expandRowKeys
          },
          on: { "row-click": _vm.onRowClick }
        },
        [
          _c("el-table-column", {
            attrs: { type: "expand" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return _vm._l(props.row.spuList, function(tag) {
                    return _c(
                      "el-tag",
                      {
                        key: tag.spuNo,
                        staticClass: "bairun-margin-l",
                        attrs: { type: "warning" }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(tag.goodsName) +
                            "【" +
                            _vm._s(tag.spuNo) +
                            "】 "
                        )
                      ]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "编号", prop: "spuGroupNo" }
          }),
          _c("el-table-column", {
            attrs: { label: "分组名称", prop: "spuGroupName" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(" " + _vm._s(scope.row.spuGroupName) + " "),
                    scope.row.isHot == 1
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "danger",
                              size: "mini",
                              effect: "plain"
                            }
                          },
                          [_vm._v("热销")]
                        )
                      : _vm._e(),
                    _vm._v("   ")
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "最后操作人", prop: "sysUserName" }
          }),
          _c("el-table-column", {
            attrs: { label: "更新时间", prop: "UpdatedAt" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.UpdatedAt)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "创建时间", prop: "CreatedAt" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.CreatedAt)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "状态", prop: "CreatedAt" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.spuGroupStatus == 1
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v("启用")
                        ])
                      : _vm._e(),
                    scope.row.spuGroupStatus == 2
                      ? _c("el-tag", { attrs: { type: "danger" } }, [
                          _vm._v("禁用")
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作区", width: "250px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.onUpdate(scope.row)
                          }
                        }
                      },
                      [_vm._v("变更")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.onStatus(scope.row, 1)
                          }
                        }
                      },
                      [_vm._v("启用")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", size: "small" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.onStatus(scope.row, 2)
                          }
                        }
                      },
                      [_vm._v("禁用")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", size: "small" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.onDelete(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.dialogVisible,
            title: _vm.dialogTitle
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              staticClass: "dialog-form",
              attrs: { model: _vm.formData, "label-position": "right" }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "bairun-required",
                  attrs: { label: "组合名称:", prop: "spuGroupName" }
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    on: {
                      input: function($event) {
                        return _vm.inputChange($event)
                      }
                    },
                    model: {
                      value: _vm.formData.spuGroupName,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "spuGroupName", $$v)
                      },
                      expression: "formData.spuGroupName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "bairun-required",
                  attrs: { label: "是否热销:", prop: "isHot" }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: {
                        change: function($event) {
                          return _vm.inputChange($event)
                        }
                      },
                      model: {
                        value: _vm.formData.isHot,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "isHot", $$v)
                        },
                        expression: "formData.isHot"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 2 } }, [_vm._v("否")]),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "bairun-required",
                  attrs: { label: "搜索商品:", prop: "groupName" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "search-spu" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            multiple: "",
                            filterable: "",
                            remote: "",
                            "collapse-tags": "",
                            size: "small",
                            placeholder: "请输入关键词搜索",
                            "remote-method": _vm.onSearchSpu
                          },
                          on: { change: _vm.onChangeSearchSpu },
                          model: {
                            value: _vm.searchSpuNoArr,
                            callback: function($$v) {
                              _vm.searchSpuNoArr = $$v
                            },
                            expression: "searchSpuNoArr"
                          }
                        },
                        _vm._l(_vm.searchSpuOptions, function(item) {
                          return _c("el-option", {
                            key: item.spuNo,
                            attrs: { label: item.goodsName, value: item.spuNo }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    _vm._l(_vm.selSpuOptions, function(item) {
                      return _c(
                        "el-tag",
                        {
                          key: item.spuNo,
                          staticClass: "bairun-margin-l",
                          attrs: { closable: "", type: "warning" },
                          on: {
                            close: function($event) {
                              return _vm.onTagClose(item.spuNo)
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(item.goodsName) +
                              "【" +
                              _vm._s(item.spuNo) +
                              "】 "
                          )
                        ]
                      )
                    }),
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.enterDialog } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }